import dev from './dev.js';
import prod from './prod.js';

// console.log('🔧 DEBUG - Environment Selection:');
// console.log('  - process.env.NODE_ENV:', process.env.NODE_ENV);
// console.log('  - REACT_APP_BACKEND_URL:', process.env.REACT_APP_BACKEND_URL);
// console.log('  - REACT_APP_BACKEND_PORT:', process.env.REACT_APP_BACKEND_PORT);

let target = process.env.NODE_ENV === 'production' ? prod : dev;
// console.log('  - Selected environment:', process.env.NODE_ENV === 'production' ? 'PRODUCTION' : 'DEVELOPMENT');

class Env {
  // Build
  static BUILD_VERSION = process.env.REACT_APP_VERSION;
  static BUILD_HASH    = process.env.REACT_APP_BUILD_HASH;
  static BUILD_DATE    = process.env.REACT_APP_BUILD_DATE;

  // API
  static HOST = target.HOST;
  static PORT = target.PORT;
}

export { Env }
